export default "https://cdn-static.gokick.com/assets/bc95401d28f090206b11ed03f14553a528aaf8ef/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";